import {
  ActivateAllAdUnitsProductMutation,
  ActivateAllAdUnitsProductMutationVariables,
} from 'gql/graphql'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { useAdUnitsProductSnackbar } from '../useAdUnitsProductSnackbar'
import { ACTIVATE_ALL_AD_UNITS_PRODUCT } from './mutation'

import type { UseActivateAllAdUnitsProduct } from './types'

export const useActivateAllAdUnitsProduct = (): UseActivateAllAdUnitsProduct => {
  const { snackbar } = useAdUnitsProductSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<
    ActivateAllAdUnitsProductMutationVariables,
    ActivateAllAdUnitsProductMutation
  >({
    mutation: ACTIVATE_ALL_AD_UNITS_PRODUCT,
    onCompleted: async (
      data: ActivateAllAdUnitsProductMutation,
      variables: ActivateAllAdUnitsProductMutationVariables,
    ) => {
      const { activateAllAdUnitsProduct } = data
      const product = variables.input.productType

      if (activateAllAdUnitsProduct?.errors) {
        const { errors } = activateAllAdUnitsProduct
        if (errors && errors.length > 0) {
          snackbar({ enabled: true, product, variant: 'error' })
        }
      } else {
        snackbar({ enabled: true, product, variant: 'success' })
      }
    },
    queriesToInvalidate: ['getAdUnitsForTable'],
  })

  const activateAllAdUnitsProduct: UseActivateAllAdUnitsProduct['activateAllAdUnitsProduct'] =
    product => {
      void mutateAsync({
        input: {
          productType: product,
        },
      })
    }

  return { activateAllAdUnitsProduct, loading }
}
